import React, { useEffect, useRef, useState } from 'react';
import './home.css';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import preloaderBook1 from '../assets/imgs/preloaderBook1.png';
import preloaderBook2 from '../assets/imgs/preloaderBook2.png';
import radwaAshour from '../assets/imgs/radwaAshour.png';
import mahmoudSalem from '../assets/imgs/mahmoudSalem.png';
import preloaderBook3 from '../assets/imgs/preloaderBook3.png';
import preloaderBook4 from '../assets/imgs/preloaderBook4.png';
import gsap from 'gsap';
import { CustomEase } from 'gsap/all';
import Modal from '../components/layout/popup';
import cibfLogoCol from '../assets/icons/cibfLogoCol.svg';
import Btn from '../components/common/btn';
import { Link } from 'react-router-dom';
import SecTitle from '../components/common/sectitle';
import historySecImg from '../assets/imgs/historySec.png';
import Footer from '../components/layout/footer';
import goldenSponsor from '../assets/icons/goldenSponsor.svg';
import officialCarrier from '../assets/icons/officialCarrier.svg';
import strategicPartner from '../assets/icons/strategicPartner.svg';
import organizedBy from '../assets/icons/organizedBy.svg';
import shippingPartner from '../assets/icons/shippingPartner.svg';
import officialTelecom from '../assets/icons/officialTelecom.svg';
import platinumSponsor from '../assets/icons/platinumSponsor.svg';
import silverSponsor from '../assets/icons/silverSponsor.svg';
import CalendarApp from '../components/common/fullCalendar';
import CountUp from '../components/common/CountUp';
import { motion } from 'framer-motion';
import VendorsSection from '../components/layout/vendors';
import { supabase } from '../supabase';

gsap.registerPlugin(CustomEase);
CustomEase.create("hop", "M0,0 C0.85,0.15,1,1,1,1");

const Home = () => {

    const [content, setContent] = useState({
        hero: {
          edition_tagline: 'Considered one of the largest book fairs in the Middle East',
          edition_number: '58th',
          honored_name: 'Radwa Ashour',
          cta_primary_label: 'Book Now',
        },
        honored: {
          section_tagline: 'Celebrating Literary Voices',
          section_subtitle: "This year’s honored personalities",
          personality_quote: 'But time does not disclose its secrets to humankind, and the possible turned impossible.',
          personality_name: 'Radwa Ashour',
          learn_more_label: 'Learn More',
        },
        about: {
          section_tagline: 'A Legacy of Literature',
          body_text: 'Since 1969, the Cairo International Book Fair has been the beating heart of Arabic literature and culture. What began as a small gathering has grown into the largest book fair in the Arab world, attracting millions of visitors from across the globe.\n\nEach year, we celebrate the power of words to inspire, educate, and unite people from all walks of life.',
          stat_1_value: '55+',
          stat_1_label: 'Years',
          stat_2_value: '2M+',
          stat_2_label: 'Visitors',
          stat_3_value: '1500+',
          stat_3_label: 'Publishers',
          explore_history_label: 'Explore History',
        },
        events: {
          section_tagline: 'Event Schedule',
          section_subtitle: "Don't miss these exciting events",
        }
      });

      useEffect(() => {
        const fetchContent = async () => {
          const { data, error } = await supabase
            .from('site_content')
            .select('*');
      
          if (error) {
            console.error('Error fetching content:', error);
            return;
          }
      
          const formattedContent = {};
      
          data.forEach((row) => {
            formattedContent[row.section] = row.content;
          });
      
          setContent((prev) => ({
            ...prev,
            ...formattedContent,
          }));
        };
      
        fetchContent();
      
        const channel = supabase
          .channel('site_content_changes')
          .on(
            'postgres_changes',
            {
              event: '*',
              schema: 'public',
              table: 'site_content',
            },
            () => {
              fetchContent();
            }
          )
          .subscribe();
      
        return () => {
          supabase.removeChannel(channel);
        };
      }, []);

    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.6,
                ease: 'easeOut'
            }
        })
    };

    const counterRef = useRef(null);
    const titleRef = useRef(null);
    const sectionRef = useRef(null);
    const hasAnimated = useRef(false);
    const imgLeftRef = useRef(null);
    const imgRightRef = useRef(null);
    
    useEffect(() => {
        gsap.set(imgLeftRef.current, { x: "-100%", opacity: 0 });
        gsap.set(imgRightRef.current, { x: "100%", opacity: 0 });
    }, []);
    
    const handleMouseEnter = () => {
        if (hasAnimated.current) return;
        hasAnimated.current = true;
        gsap.fromTo(imgLeftRef.current,
            { x: "-100%", opacity: 0 },
            { x: 20, opacity: 1, duration: 1, ease: "power3.out" }
        );
        gsap.fromTo(imgRightRef.current,
            { x: "100%", opacity: 0 },
            { x: -20, opacity: 1, duration: 1, ease: "power3.out" }
        );
    };

    useEffect(() => {
        const h1 = titleRef.current;
        if (!h1) return;

        const words = h1.innerText.split(" ");
        h1.innerHTML = words
            .map(word => `<span class="word"><span>${word}</span></span>`)
            .join(" ");

        const counter = { value: 0 };

        const counterTl = gsap.timeline();
        const revealTl = gsap.timeline();

        counterTl.to(counter, {
            value: 100,
            duration: 5,
            ease: "power2.out",
            onUpdate: () => {
                if (counterRef.current) {
                    counterRef.current.textContent = Math.floor(counter.value);
                }
            },
        });

        revealTl
        .fromTo(".img",
            { y: "50%", scale: 0.5, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.05, duration: 1, ease: "hop" }
        )
        .to(".hero-images", { gap: "0.75vw", duration: 1, ease: "hop" })
        .to(".img", { scale: 1, duration: 1, ease: "hop" }, "<")
        .to(".img:not(.hero-img)", {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
            duration: 1,
            stagger: 0.1,
            ease: "hop",
        })
        .to(".hero-img", { scale: 3, duration: 1, ease: "hop" })
        .to(".hero-overlay", {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
            duration: 1,
            ease: "hop",
            onComplete: () => {
                gsap.set(".hero-images", { zIndex: 5 });
                const heroImg = document.querySelector(".hero-img");
                const rect = heroImg.getBoundingClientRect();
                const distanceToBottom = window.innerHeight - rect.bottom;
                gsap.to(".hero-img", {
                    y: `+=${distanceToBottom}`,
                    duration: 0.2,
                    ease: "hop",
                });
            }
        }, "-=0.5")
        .fromTo(".word span",
            { y: "100%" },
            { y: "0%", duration: 0.8, stagger: 0.1, ease: "power3.out" },
            "-=0.5"
        );

        return () => {
            counterTl.kill();
            revealTl.kill();
        };
    }, []);

    

    return (
        <>
            <ScrollHideHeader />
            <main id='main-content'>
                <div className="bgDecor"></div>
                <div className='hero'>
                    <div className="hero-overlay">
                        <div className="counter">
                            <h1 ref={counterRef}>0</h1>
                        </div>
                    </div>
                    <div className="hero-images">
                        <img className='img' src={preloaderBook1} alt="" />
                        <img className='img' src={preloaderBook2} alt="" />
                        <img className='img hero-img' src={radwaAshour} alt="" />
                        <img className='img' src={preloaderBook3} alt="" />
                        <img className='img' src={preloaderBook4} alt="" />
                    </div>
                    <div className="heroContainer">
                        <div className="heroContent">
                            <h4>{content.hero.edition_tagline}, the {content.hero.edition_number} edition features Egyptian writer and scholar {content.hero.honored_name}.</h4>
                            <Link className='link' to='/Book'>
                            <Btn btnText={content.hero.cta_primary_label} btnStyle="mainBtn" />
                            </Link>
                        </div>
                        <img src={cibfLogoCol} alt="Cairo International Book Fair logo" />
                    </div>
                    <div className="hero-header">
                        <h1 ref={titleRef} className="hero-header-fill">RADWA ASHOUR</h1>
                    </div>
                </div>
                <motion.div custom={1} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                    <section id='personalities' ref={sectionRef} onMouseEnter={handleMouseEnter}>
                    <SecTitle secTitle={`{ ${content.honored.section_tagline} }`} secDesc={content.honored.section_subtitle}/>
                        <div className="personalities">
                            <div className="personality">
                                <h1>R</h1>
                                <img ref={imgLeftRef} src={radwaAshour} className='personalityImg' alt="Radwa Ashour" />
                            </div>
                            <div className="personalitiesQuote">
                                <div className="quote">
                                <h3>“{content.honored.personality_quote}”</h3>
                                <h4>- {content.honored.personality_name} -</h4>
                                </div>
                                <Btn btnText="Learn More" btnStyle="mainBtn displayFlex" />
                            </div>
                            <div className="personalityFlipped displayFlex">
                                <h1>M</h1>
                                <img ref={imgRightRef} src={mahmoudSalem} className='personalityImgRight' alt="Mahmoud Salem" />
                            </div>
                            <Btn btnText="Learn More" btnStyle="mainBtn displayNone" />
                        </div>
                    </section>
                </motion.div>
                <motion.div custom={1} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                    <VendorsSection/>
                </motion.div>
                <section id='history'>
                    <motion.div custom={1} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} id='history'>
                        <img src={historySecImg} alt="The 1969 Book Fair" />
                        <div className="history">
                            <h2>&#123; A Legacy of Literature &#125;</h2>
                            <h4>Since 1969, the Cairo International Book Fair has been the beating heart of Arabic literature and culture. What began as a small gathering has grown into the largest book fair in the Arab world, attracting millions of visitors from across the globe.</h4>
                            <h4>Each year, we celebrate the power of words to inspire, educate, and unite people from all walks of life.</h4>
                            <div className="counters">
                                <div className="historyCounter">
                                    <div className="counting">
                                        <CountUp from={0} to={55} separator="," direction="up" duration={1} className="count-up-text" delay={0} />
                                        <h1>+</h1>
                                    </div>
                                    <p>Years</p>
                                </div>
                                <div className="historyCounter">
                                    <div className="counting">
                                        <CountUp from={0} to={2000000} separator="," direction="up" duration={1} className="count-up-text" delay={0} />
                                        <h1>+</h1>
                                    </div>
                                    <p>Years</p>
                                </div>
                                <div className="historyCounter">
                                    <div className="counting">
                                        <CountUp from={0} to={1500} separator="," direction="up" duration={1} className="count-up-text" delay={0} />
                                        <h1>+</h1>
                                    </div>
                                    <p>Years</p>
                                </div>
                            </div>
                            <Link to="/History" className='link'>
                                <Btn btnStyle="mainBtn" btnText="Explore History" />
                            </Link>
                        </div>
                    </motion.div>
                </section>
                <section id='events'>
                    <motion.div
                        custom={0}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <SecTitle secTitle="{ Event Schedule }" secDesc="Don't miss these exciting events" />
                    </motion.div>

                    <motion.div
                        custom={1}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <CalendarApp />
                    </motion.div>
                </section>
                <section id='partners'>
                <motion.div
                        custom={0}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <SecTitle secTitle="{ Partners & SPONSORS }" secDesc="Don’t miss these exciting events" />
                    </motion.div>

                    <motion.div
                        custom={1}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                    <div class="partnersCarousel">
                        <div className="group">
                            <img src={goldenSponsor} alt="Midar logo" />
                            <img src={officialCarrier} alt="Egyptair logo" />
                            <img src={strategicPartner} alt="EIEC logo" />
                            <img src={organizedBy} alt="Dmedia logo" />
                            <img src={shippingPartner} alt="Egypt Post logo" />
                            <img src={officialTelecom} alt="WE logo" />
                            <img src={platinumSponsor} alt="National Bank of Egypt logo" />
                            <img src={silverSponsor} alt="Edita logo" />
                        </div>
                        <div aria-hidden className="group">
                            <img src={goldenSponsor} alt="Midar logo" />
                            <img src={officialCarrier} alt="Egyptair logo" />
                            <img src={strategicPartner} alt="EIEC logo" />
                            <img src={organizedBy} alt="Dmedia logo" />
                            <img src={shippingPartner} alt="Egypt Post logo" />
                            <img src={officialTelecom} alt="WE logo" />
                            <img src={platinumSponsor} alt="National Bank of Egypt logo" />
                            <img src={silverSponsor} alt="Edita logo" />
                        </div>
                    </div>
                    </motion.div>
                </section>
        <Modal />
        <Footer />
            </main>
        </>
    );
}

export default Home;